import { useParams } from 'react-router-dom';

import { AppToolsSmartLinkPage } from '~/components/pages/AppToolsSmartLinkPage';
import { DashboardTemplate } from '~/components/templates/DashboardTemplate';
import { useNavigate } from '~/components/utils/Navigation';

export const AppToolsSmartLinkRoute: React.FC = () => {
  const { appId } = useParams();
  const navigate = useNavigate();

  if (!appId) {
    navigate('/');

    return null;
  }

  return (
    <DashboardTemplate appId={appId}>
      <AppToolsSmartLinkPage appId={appId} />
    </DashboardTemplate>
  );
};
